<tec-modal
    [isVisible]="true"
    [title]="`WORKFLOWS.CREATE_JSON.TITLE${canEdit ? (json ? '_EDIT' : '') : '_VIEW'}` | translate"
    [tagImage]="{ icon: 'icon-flow', status: 'simple' }"
    [buttonPrimaryLabel]="canEdit ? primaryButtonLabel : undefined"
    [buttonSecondaryLabel]="canEdit ? ('BUTTON.CANCEL' | translate) : undefined"
    (closeEvent)="closeModal($event)"
>
    @if (showError) {
    <div #errorAlert>
        <tec-alert [hiddenCloseButton]="true" [msg]="showError" [status]="'error'" (closeAlert)="showError = ''" />
    </div>
    }

    <tec-code-editor
        language="json"
        [readonly]="!canEdit"
        [(ngModel)]="editorValue"
        [hasError]="!!showError"
        [withActions]="true"
    />
</tec-modal>
